'use client';

import { useRouter } from 'next/navigation';
import React, { useCallback } from 'react';
import { getSiteConfig } from '../config/sites';

const site = getSiteConfig();

// Style object for 404 page container (z-index така че бутонът да е над декорациите)
const notFoundStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  textAlign: 'center',
  padding: '20px',
  gap: '1rem',
  position: 'relative',
  zIndex: 1,
};

const buttonStyle = {
  color: `var(--primary-500, ${site.theme.primary500})`,
  fontWeight: 600,
  cursor: 'pointer',
  position: 'relative',
  zIndex: 2,
  display: 'inline-block',
  padding: '12px 24px',
  marginTop: '8px',
  background: 'none',
  border: `2px solid var(--primary-500, ${site.theme.primary500})`,
  borderRadius: '8px',
  font: 'inherit',
};

export default function NotFound() {
  const router = useRouter();
  const goHome = useCallback(() => router.push('/'), [router]);

  return (
    <div style={notFoundStyle}>
      <h1>404 – Страницата не е намерена</h1>
      <p>Страницата, която търсите, не съществува.</p>
      <button type="button" style={buttonStyle} onClick={goHome}>
        Към начало
      </button>
    </div>
  );
}
